export default __webpack_public_path__ + "static/media/NSTP.1ba2924c.png";